const filterListModalFilterService = {
  filter: 'FILTROS',
  clear: 'limpar filtros'
};

export default filterListModalFilterService;
